module.exports = __webpack_public_path__ + "static/media/icon-instagram.ebd2ed1f.svg";